// components/PrayerDisplay/IqamahOverlay.jsx
import React, { useEffect, useState } from "react";
import Mobile from "../../assets/Mobile.png";
import moment from "moment-timezone";

const IqamahOverlay = ({ nextEvent, timezone }) => {
  const [currentTime, setCurrentTime] = useState(moment.tz(moment(), timezone));
  
  const prayerName = nextEvent?.name || "PRAYER";

  useEffect(() => {
  //console.log("📢 [IqamahOverlay] Visible for:", prayerName, "at", currentTime.format("hh:mm:ss A"));
}, [currentTime, prayerName]);

  // Format time without leading zero
  const timePart = currentTime.format("h:mm");
  const meridiem = currentTime.format("A");

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(moment.tz(moment(), timezone));
    }, 1000);
    return () => clearInterval(interval);
  }, [timezone]);
  
  return (
    <div className="fixed inset-0 z-50 bg-black flex flex-col items-center justify-center text-white">
      <div className="absolute top-4 left-4 flex items-end space-x-1">
        <span className="text-[6svh] font-bold leading-none">{timePart}</span>
        <span className="text-[4svh] font-semibold leading-tight self-end">
          {meridiem}
        </span>
      </div>
      <div className="text-8xl font-bold mb-6">IQAMAH TIME</div>
      <img src={Mobile} alt="Mobile" className="w-[200px] opacity-80" />
      {/* <div className="text-3xl mt-6 uppercase"> */}
        {/* {prayerName} Iqamah in Progress */}
      {/* </div> */}
    </div>
  );
};

export default IqamahOverlay;